import * as React from 'react';
import { useDispatch } from 'react-redux';

import { applyMicrofrontendFilters } from '../../../actions/filters/applyMicrofrontendFilters';
import { IFiltersUpdatedEventDetail } from '../../../types/desktopFiltersMicrofrontend';
import { TThunkDispatch } from '../../../types/redux';

const FILTERS_UPDATED_EVENT = 'filters:updated';

export function useFiltersUpdatedEvent(): void {
  const dispatch = useDispatch<TThunkDispatch>();

  React.useEffect(() => {
    const handleFiltersUpdated = ({ detail }: CustomEvent<IFiltersUpdatedEventDetail>) => {
      dispatch(applyMicrofrontendFilters(detail));
    };

    window.addEventListener(FILTERS_UPDATED_EVENT, handleFiltersUpdated);

    return () => {
      window.removeEventListener(FILTERS_UPDATED_EVENT, handleFiltersUpdated);
    };
  }, [dispatch]);
}
